import React from 'react';
import { Link } from 'react-router';
import useTheme from '../hooks/useTheme';
import { megaGreenData } from '../data/data';

export const Footer: React.FC = () => {
  const { theme } = useTheme();
  const primaryLinks = megaGreenData.nav.primary.filter(link => link.path !== '/');
  const secondaryLinks = megaGreenData.nav.secondary;

  return (
    <footer
      style={{
        background: `linear-gradient(180deg, ${theme.colors.ink} 0%, ${theme.colors.ink}dd 100%)`,
        borderTop: `1px solid ${theme.colors.border}40`,
        paddingTop: '48px',
        paddingBottom: '24px',
        position: 'relative',
      }}
    >
      <div
        style={{
          maxWidth: '1120px',
          margin: '0 auto',
          padding: '0 20px',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '48px',
            marginBottom: '40px',
          }}
          className="footerGrid"
        >
          <div>
            <h3
              style={{
                fontSize: '18px',
                fontWeight: 600,
                color: theme.text.contrast,
                marginBottom: '12px',
              }}
            >
              {megaGreenData.site.name}
            </h3>
            <p
              style={{
                color: `${theme.text.contrast}cc`,
                fontSize: '14px',
                lineHeight: 1.6,
                marginBottom: '16px',
              }}
            >
              {megaGreenData.site.description}
            </p>
            <div
              style={{
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  backgroundColor: theme.palette.primary.main,
                }}
              />
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  backgroundColor: theme.palette.secondary.main,
                }}
              />
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  backgroundColor: '#F0A02C',
                }}
              />
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  backgroundColor: '#684190',
                }}
              />
            </div>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '32px',
            }}
          >
            <div>
              <h3
                style={{
                  fontSize: '18px',
                  fontWeight: 600,
                  color: theme.text.contrast,
                  marginBottom: '12px',
                }}
              >
                Primary Links
              </h3>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                }}
              >
                {primaryLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    style={{
                      color: `${theme.text.contrast}aa`,
                      textDecoration: 'none',
                      fontSize: '14px',
                      transition: 'color 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = theme.colors.accent;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = `${theme.text.contrast}aa`;
                    }}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h3
                style={{
                  fontSize: '18px',
                  fontWeight: 600,
                  color: theme.text.contrast,
                  marginBottom: '12px',
                }}
              >
                Legal
              </h3>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                }}
              >
                {secondaryLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    style={{
                      color: `${theme.text.contrast}aa`,
                      textDecoration: 'none',
                      fontSize: '14px',
                      transition: 'color 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = theme.colors.highlight;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = `${theme.text.contrast}aa`;
                    }}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            borderTop: `1px solid ${theme.colors.border}40`,
            paddingTop: '20px',
            textAlign: 'center',
            color: `${theme.text.contrast}aa`,
            fontSize: '13px',
          }}
        >
          <div>© {new Date().getFullYear()} {megaGreenData.site.name}. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};

